/**
 * 1 prompt → many sub-queries → themed clusters.
 *
 * Spec 250 (review P1-9): this was an SVG whose labels were 9–11 user units in
 * a scaling viewBox — about 12–15px on a desktop and about 6px on a phone. It
 * is HTML now, on the Flow diagram's node and edge recipe, so every label has
 * a real size at every width. The prompt is the one node that matters, so it
 * is the inverted (ink) node; nothing is Skagen. Illustrative values, not data.
 */
const SUBQUERIES = ['best for flat feet?', 'most durable?', 'cheapest reliable?', 'good for marathons?'] as const;
const CLUSTERS = ['Fit & comfort', 'Value'] as const;

export function FanOutDiagram() {
  return (
    <figure className="hub-flow-figure" data-testid="hiw-fanout">
      <div
        className="grid items-center gap-3 sm:grid-cols-[minmax(0,1fr)_32px_minmax(0,1.3fr)_32px_minmax(0,1fr)]"
        role="img"
        aria-label="One prompt fans out into many sub-queries, which group into themed clusters."
      >
        <div className="hub-flow__node" aria-current="step">
          <span className="hub-flow__name">Your prompt</span>
          <span className="hub-flow__note">“running shoes?”</span>
        </div>
        <span className="hub-flow__edge hidden sm:block" aria-hidden="true" />
        <ul className="m-0 flex list-none flex-col gap-2 p-0">
          {SUBQUERIES.map((q) => (
            <li key={q} className="hub-flow__node py-2">
              <span className="hub-flow__note text-[var(--hub-color-ink)]">{q}</span>
            </li>
          ))}
        </ul>
        <span className="hub-flow__edge hidden sm:block" aria-hidden="true" />
        <ul className="m-0 flex list-none flex-col gap-2 p-0">
          {CLUSTERS.map((c) => (
            <li key={c} className="hub-flow__node">
              <span className="hub-flow__name">{c}</span>
              <span className="hub-flow__note">Cluster</span>
            </li>
          ))}
        </ul>
      </div>
      <figcaption className="hub-flow__caption">
        One prompt, many sub-queries, a few clusters.
      </figcaption>
    </figure>
  );
}
